import { getSequences } from '@/services/sequencesService';
import { useQuery } from '@tanstack/react-query';

export const useQuerySequences = () => {
	return useQuery({
		queryKey: ['list-sequences'],
		queryFn: getSequences
	});
};
